
if(!customElements.get('color-info')){
    customElements.define("color-info", class ColorInfo extends HTMLElement {
        constructor(){
            super()
            
            this.openModalBtn = this.querySelector('.open-color-info')
            this.colorInfo = this.querySelector('.color-info')
            this.overlay = this.querySelector('.color-info__overlay')
            this.close = this.querySelector('.color-info__close')

            this.openModalBtn.addEventListener('click', this.openModal.bind(this))
            this.overlay.addEventListener('click', this.closeModal.bind(this))
            this.close.addEventListener('click', this.closeModal.bind(this))
            
        }

        openModal(){
            this.colorInfo.classList.remove("hidden")
            document.querySelector('body').classList.add('opened-color-info');
        }
        
        closeModal(){
            this.colorInfo.classList.add("hidden");
            document.querySelector('body').classList.remove('opened-color-info');
        }
    })
}